import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { useClientAuth } from '../../auth/ClientAuthContext';
import API_BASE from '../../utils/api';
import { flattenPurchaseOrderItems, findMatchingItem, StatusCard } from './tabs/itemStatusHelpers';

export default function ClientItemStatusDetail() {
  const { projectId, itemId } = useParams();
  const { clientAuth } = useClientAuth();
  const [items, setItems] = useState([]);
  const [purchaseOrders, setPurchaseOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!clientAuth?.token) return;
    const authHeaders = { Authorization: `Bearer ${clientAuth.token}` };

    Promise.all([
      fetch(`${API_BASE}/api/client/projects/${projectId}/items`, {
        credentials: 'include',
        headers: authHeaders,
      }).then((r) => (r.ok ? r.json() : [])),
      fetch(`${API_BASE}/api/client/projects/${projectId}/purchase-orders`, {
        credentials: 'include',
        headers: authHeaders,
      }).then((r) => (r.ok ? r.json() : [])),
    ])
      .then(([its, pos]) => {
        setItems(its || []);
        setPurchaseOrders(pos || []);
      })
      .catch((err) => setError(err.message || 'Failed to load item.'))
      .finally(() => setLoading(false));
  }, [clientAuth, projectId, itemId]);

  if (loading) return <p style={{ color: '#6b7280', fontSize: 14 }}>Loading…</p>;
  if (error) {
    return (
      <>
        <Link to={`/client/projects/${projectId}`} className="cp-back-link">← Back to project</Link>
        <p className="cp-error">{error}</p>
      </>
    );
  }

  const matched = items.find((it) => it.itemId === itemId) || null;
  const poItem = flattenPurchaseOrderItems(purchaseOrders).find((it) => it.itemId === itemId) || null;

  if (!matched && !poItem) {
    return (
      <>
        <Link to={`/client/projects/${projectId}`} className="cp-back-link">← Back to project</Link>
        <p className="cp-empty">Item not found.</p>
      </>
    );
  }

  const displayItem = poItem || {
    itemId: matched.itemId,
    name: matched.name,
    room: matched.room,
    imageUrl: matched.imageUrl,
    quantity: matched.qty,
    status: null,
    poDate: null,
  };
  const matchedItem = matched || findMatchingItem(items, displayItem);
  const room = displayItem.room || 'Unspecified';

  return (
    <div className="cp-animate">
      <Link to={`/client/projects/${projectId}`} className="cp-back-link">← Back to project</Link>

      <div className="cp-room-group">
        <p className="cp-room-heading">{room}</p>
        <StatusCard item={displayItem} matched={matchedItem} projectId={projectId} />
      </div>
    </div>
  );
}
